// Import smaller configuration files
import { layers } from 'config/layers.config';
import { text } from 'config/staticText.config';
import { esri } from 'config/esri.config';

const config = {
  layers,
  text,
  esri
};

export default config;
